import React from "react";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Box,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Typography from "@mui/material/Typography";

export default function SimpleConfigTable({ columns, rows, onEdit, onLogicalDelete, onRowClick }) {
  const hasDelete = typeof onLogicalDelete === "function";
  const hasRowClick = typeof onRowClick === "function";
  return (
    <TableContainer className={"box-shadow"} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="config table">
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={{ color: "#B3B3B3", width: 20 }}>
              Sl.No
            </TableCell>
            {columns.map((c) => (
              <TableCell key={c.key} align="left" sx={{ color: "#B3B3B3" }}>
                {c.label}
              </TableCell>
            ))}
            <TableCell align="center" sx={{ color: "#B3B3B3" }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.length > 0 ? (
            rows.map((r, idx) => (
              <TableRow
                hover
                key={r.id || idx}
                sx={hasRowClick ? { cursor: "pointer" } : undefined}
              >
                <TableCell onClick={() => hasRowClick && onRowClick(r)}>{idx + 1}</TableCell>
                {columns.map((c) => (
                  <TableCell
                    key={`${r.id}_${c.key}`}
                    sx={{ color: "#3D3D3D" }}
                    onClick={() => hasRowClick && onRowClick(r)}
                  >
                    {r?.[c.key] ?? "-"}
                  </TableCell>
                ))}
                <TableCell align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                    <Tooltip title={"Edit"}>
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          onEdit?.(r);
                        }}
                        sx={{ bgcolor: "#fff", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;" }}
                      >
                        <DriveFileRenameOutlineIcon />
                      </IconButton>
                    </Tooltip>
                    {hasDelete && (
                      <Tooltip title={"Delete"}>
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            onLogicalDelete?.(r.id);
                          }}
                        >
                          <DeleteForeverIcon sx={{ color: "red" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length + 2} style={{ textAlign: "center" }}>
                <Typography style={{ color: "red" }}>No records</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
